import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <defs>
      <rect id="a" width="20" height="20" rx="8" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g stroke="#979797" strokeWidth="1.5">
        <path d="M4.52 4.52l10.96 10.96M4.52 15.48L15.48 4.52" />
      </g>
    </g>
  </svg>
);
